module.exports = __webpack_public_path__ + "img/examination1.aa2da10d.png";